import { personalizedSortFragment } from './searchFragment';

const buildQuery = (
	shouldAddPriceRangeIntervals = false,
	includeCategory = true,
) => {
	const priceRangeQuery = shouldAddPriceRangeIntervals
		? ' priceRange { intervals { range { from to } total } }'
		: '';

	const categoryVariable = includeCategory ? '$categoryGuid: String!,' : '';

	const categoryQueries = includeCategory
		? `
      isPermitted(
        location: { city: $city, state: $state },
        categoryGuid: $categoryGuid
      ) {
        flag
      }
      searchCopy(
        categoryGuid: $categoryGuid,
        location: { city: $city, state: $state},
      ) {
        html
      }`
		: '';

	return `
    query(
      ${categoryVariable}
      $city: String,
      $filters: [String],
      $fixedPageSize: Boolean,
      $limit: Int,
      $page: Int,
      $rangeFilters: [RangeInput],
      $search_fallback_offset: Int,
      $seed: String
      $sort: [SortInput!],
      $state: String,
      $member: MemberInput,
      $searchString: String,
      $skipCrossCategoryClassification: Boolean
    ){
      search: liteThresholdSearch (
        filters: $filters,
        fixedPageSize: $fixedPageSize,
        limit: $limit,
        location: { city: $city, state: $state },
        page: $page,
        rangeFilters: $rangeFilters,
        seed: $seed,
        sort: $sort,
        member: $member,
        searchString: $searchString,
        skipCrossCategoryClassification: $skipCrossCategoryClassification
      ) {
        boundingBox {
          topLeft {
            latitude
            longitude
          }
          bottomRight {
            latitude
            longitude
          }
        }
        marketCode
        pagination {
          limit
          count
          page
        }
        profiles {
          ...PersonalizedSortProfileProperties
        }
        total {
          profiles
        }
        supplemental {
          ...PersonalizedSortProfileProperties
        }
        sort {
          type
          order
          variation
          version
          scoreType
        }
        selectedCategories
        ${priceRangeQuery}
      }
      searchFallback(
        filters: $filters,
        location: { city: $city, state: $state},
        offset: $search_fallback_offset,
        limit: $limit,
        sort: $sort,
        seed: $seed,
      ) {
        citySearch
        stateSearch
        categorySearch
        home
      }
      ${categoryQueries}
    }
    ${personalizedSortFragment}
  `;
};

export default buildQuery;
